import { postRequest, delRequest } from "./axios";

export const login = params => postRequest(`login`, params);
export const logout = params => delRequest(`logout`, params);
export const resetPassword = params => postRequest(`reset-pw`, params);
export const changePassword = params => postRequest(`set-pw`, params);
